module.exports = __webpack_public_path__ + "rijksoverheidsanstext-bolditalic_2_0.woff2?13037c1511aa3c8ddcaf916808f4e20f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rijksoverheidsanstext-bolditalic_2_0.woff2
// module id = 543
// module chunks = 0